import { GetStaticPropsResult } from 'next';

import { getKnots } from '../../src/api/contentful/getKnots';
import { NOT_FOUND_WITH_REVALIDATION, REVALIDATE } from '../../src/constants/next';
import { reportMykissClientError } from '../../src/helpers/errorHandling/client';
import { IPageMetadata } from '../../src/interfaces/nextjs';
import { IKnotsProps, Knots } from '../../src/views/Knots/Knots';

export async function getStaticProps(): Promise<GetStaticPropsResult<IPageMetadata & IKnotsProps>> {
  try {
    const knotsCollection = await getKnots();
    const { items } = knotsCollection;

    return {
      props: {
        _page: 'knots',
        _pageTitle: 'Knots',
        knots: items,
      },
      revalidate: REVALIDATE.DAILY,
    };
  } catch (error) {
    reportMykissClientError(error);
    return NOT_FOUND_WITH_REVALIDATION;
  }
}

export default Knots;
